<script setup>
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Editor from 'dashboard/components-next/Editor/Editor.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  faq: { type: Object, default: () => ({}) },
  submitLabel: { type: String, required: true },
});

const emit = defineEmits(['submit', 'cancel']);
const { t } = useI18n();
const MAX_LENGTH = 10000;

const state = reactive({
  question: '',
  answer: '',
});

watch(
  () => props.faq,
  next => {
    state.question = next?.question || '';
    state.answer = next?.answer || '';
  },
  { immediate: true }
);

const handleSubmit = () => {
  emit('submit', { question: state.question, answer: state.answer });
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent="handleSubmit">
    <Input
      v-model="state.question"
      :label="t('ARROWS_AI.FAQS.QUESTION')"
      :placeholder="t('ARROWS_AI.FAQS.QUESTION_PLACEHOLDER')"
    />
    <Editor
      v-model="state.answer"
      :label="t('ARROWS_AI.FAQS.ANSWER')"
      :placeholder="t('ARROWS_AI.FAQS.ANSWER_PLACEHOLDER')"
      :max-length="MAX_LENGTH"
      :enable-canned-responses="false"
    />
    <div class="flex items-center justify-between w-full gap-3">
      <Button
        type="button"
        variant="faded"
        color="slate"
        class="w-full bg-n-alpha-2 text-n-blue-11 hover:bg-n-alpha-3"
        :label="t('ARROWS_AI.CANCEL')"
        @click="emit('cancel')"
      />
      <Button type="submit" class="w-full" :label="submitLabel" />
    </div>
  </form>
</template>
